export const isTabActive = (pathname: string, link?: string) => {
  if (!link) {
    return false;
  }

  const hasTrailingSlash = link.endsWith('/');
  const normalizedLink = hasTrailingSlash ? link : `${link}/`;

  return pathname.includes(normalizedLink);
};
